import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRouteSnapshot} from '@angular/router';

import {ImpactAssessmentService} from '../../impact-assessment/services/impact-assessment.service';
import {AuthService} from '../services/auth.service';

@Injectable()
export class ImpactAssessmentResolve {
  constructor(
    private impactAssessmentService: ImpactAssessmentService,
    private auth: AuthService,
    private titleService: Title
  ) {}

  resolve(route: ActivatedRouteSnapshot) {
    const nodeId = route.params['nodeId'];
    const refModelId = route.params['refModelId'];

    this.titleService.setTitle('Impact Assessment');
    return this.impactAssessmentService.fetchNodeData(refModelId, nodeId);
  }
}
